import { TranslationDictionary } from '@domgen/dgx-fe-i18n';
import { FeaturePaymentMethodTranslationKeys } from './feature-payment-method-translation-keys.type';

export type FeaturePaymentMethodTranslationDictionary =
  TranslationDictionary<FeaturePaymentMethodTranslationKeys>;
